import Swiper from 'swiper'
import { Navigation, Pagination, EffectFade, Grid } from 'swiper/modules'

export const initializeCareAlgorithmsGallery = () => {
  const careAlgorithmsGallery = document.querySelector('.care-algorithms .algorithms')

  if (!careAlgorithmsGallery) return

  const swiper = new Swiper(careAlgorithmsGallery, {
    // Swiper options
    loop: true,
    pagination: {
      el: '.cco-app-controls .pagination',
      clickable: true,
      type: 'bullets',
      renderBullet: function (index, className) {
        return `<span class="${className}">${index + 1}</span>`;
      }
    },
    navigation: {
      nextEl: '.cco-app-controls .button-next',
      prevEl: '.cco-app-controls .button-prev'
    },
    modules: [Navigation, Pagination],
  })
}

export const initializeRedFlagsGallery = () => {
  const redFlagsGallery = document.querySelector('.red-flags .red-flags-list');
  const buttonsContainer = document.querySelector('.red-flags .red-flags-buttons');
  const buttons = buttonsContainer ? Array.from(buttonsContainer.querySelectorAll('button')) : [];

  if (!redFlagsGallery) return

  const swiper = new Swiper(redFlagsGallery, {
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: true,
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    modules: [EffectFade]
  });

  // Button click event to control Swiper
  buttons.forEach((button, idx) => {
    button.addEventListener('click', () => {
      swiper.slideTo(idx);
      // Update active button
      buttons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
    });
  });

  // Sync active button on slide change (in case of swipe)
  swiper.on('slideChange', () => {
    const activeIdx = swiper.realIndex || swiper.activeIndex;
    buttons.forEach((btn, idx) => {
      btn.classList.toggle('active', idx === activeIdx);
    });
  });
}

export const initializeActiveProjectsGallery = () => {
  console.log('Initializing Active Projects Gallery');
  const activeProjectsGallery = document.querySelector('.active-projects-list');
  const controls = activeProjectsGallery.querySelector('.cco-app-controls');

  console.log(controls)

  if (!activeProjectsGallery) return

  const swiper = new Swiper(activeProjectsGallery, {
    loop: true,
    spaceBetween: 20,
    pagination: {
      el: controls.querySelector('.pagination'),
      clickable: true,
      type: 'bullets',
      renderBullet: function (index, className) {
        return `<span class="${className}">${index + 1}</span>`;
      }
    },
    navigation: {
      nextEl: controls.querySelector('.button-next'),
      prevEl: controls.querySelector('.button-prev')
    },
    modules: [Navigation, Pagination],
  })
}

export const initializeNetworkUpdatesGallery = () => {
  const networkUpdatesGallery = document.querySelector('.network-updates .selected-meeting-summaries')

  if (!networkUpdatesGallery) return

  const swiper = new Swiper(networkUpdatesGallery, {
    // Swiper options
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      768: {
        spaceBetween: 63
      },
    },
    pagination: {
      el: networkUpdatesGallery.querySelector('.cco-app-controls .pagination'),
      clickable: true,
      type: 'bullets',
      renderBullet: function (index, className) {
        return `<span class="${className}">${index + 1}</span>`;
      }
    },
    navigation: {
      nextEl: networkUpdatesGallery.querySelector('.cco-app-controls .button-next'),
      prevEl: networkUpdatesGallery.querySelector('.cco-app-controls .button-prev')
    },
    modules: [Navigation, Pagination, Grid],
  })
}

export const initializeMediaItemsGallery = () => {
  const mediaItemsGallery = document.querySelector('.in-the-media .selected-media-items')

  if (!mediaItemsGallery) return

  const swiper = new Swiper(mediaItemsGallery, {
    // Swiper options
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 36,
    breakpoints: {
      768: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 48,
      },
    },
    pagination: {
      el: mediaItemsGallery.querySelector('.cco-app-controls .pagination'),
      clickable: true,
      type: 'bullets',
      renderBullet: function (index, className) {
        return `<span class="${className}">${index + 1}</span>`;
      }
    },
    navigation: {
      nextEl: mediaItemsGallery.querySelector('.cco-app-controls .button-next'),
      prevEl: mediaItemsGallery.querySelector('.cco-app-controls .button-prev')
    },
    modules: [Navigation, Pagination],
  })
}

export const initializeStoryGallery = () => {
  const storySection = document.querySelector('section.stories');
  const storyGallery = storySection ? storySection.querySelector('.swiper') : null;
  const controlsContainer = storySection ? storySection.querySelector('.cco-app-controls') : null;

  if (!storyGallery) return;

  const swiper = new Swiper(storyGallery, {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 1
      }
    },
    pagination: {
      el: controlsContainer.querySelector('.pagination'),
      clickable: true,
      type: 'bullets',
      renderBullet: function (index, className) {
        return `<span class="${className}">${index + 1}</span>`;
      }
    },
    navigation: {
      nextEl: controlsContainer.querySelector('.button-next'),
      prevEl: controlsContainer.querySelector('.button-prev')
    },
    modules: [Navigation, Pagination],
  });

  // Helper to update controls visibility
  function updateControlsVisibility() {
    if (!controlsContainer) return;
    // Get current slidesPerView (may be 'auto' or a number)
    let slidesPerView = swiper.params.slidesPerView;
    if (swiper.params.breakpoints) {
      // Find the current breakpoint
      const breakpoints = swiper.params.breakpoints;
      const windowWidth = window.innerWidth;
      let matched = swiper.originalParams.slidesPerView || 1;
      Object.keys(breakpoints).sort((a, b) => a - b).forEach(bp => {
        if (windowWidth >= bp && breakpoints[bp].slidesPerView) {
          matched = breakpoints[bp].slidesPerView;
        }
      });
      slidesPerView = matched;
    }
    // Hide controls if slides <= slidesPerView
    if (swiper.slides.length <= slidesPerView) {
      controlsContainer.style.display = 'none';
    } else {
      controlsContainer.style.display = '';
    }
  }

  // Initial check
  updateControlsVisibility();
  // Update on resize and breakpoint change
  swiper.on('breakpoint', updateControlsVisibility);
  swiper.on('resize', updateControlsVisibility);
  swiper.on('update', updateControlsVisibility);
}